import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { distinct } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SliderService {
  private activeCards = new ReplaySubject<number>();
  
  constructor() { }

  emitActiveCards = (index:number) => {
    this.activeCards.next(index);
  }

  getActiveCards$ = () => {
    return this.activeCards.pipe(distinct());
  }

}